module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "微信扫码登录",
      "width": "500px",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      },
      "close": _vm.closeFun
    }
  }, [_c('div', [_c('div', {
    staticClass: "wxpaydv"
  }, [_c('div', {
    staticClass: "pay-msg"
  }, [_vm._v("请使用微信扫一扫!")]), _vm._v(" "), _c('div', {
    staticClass: "pay-wars"
  }, [_vm._v("登录过程中请勿刷新页面或关闭浏览器!!!")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loginOk),
      expression: "!loginOk"
    }],
    ref: "wxqrcode",
    staticClass: "wxqrcode"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginOk),
      expression: "loginOk"
    }],
    staticStyle: {
      "line-height": "200px"
    }
  }, [_vm._v("登录成功,正在刷新页面")]), _vm._v(" "), _c('div', {
    staticClass: "wxpayimg"
  }, [_c('img', {
    attrs: {
      "src": "//static.jazpan.com/img/weixinlg.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    on: {
      "click": function($event) {
        return _vm.onWaitFun(false)
      }
    }
  }, [_vm._v("我已扫码完成")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60c6b540"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WxLoginDlg.vue
// module id = 1171
// module chunks = 1